import {Component, HostListener, Input} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../shared/store/store';
import {dialogOpen} from '../../../../shared/store/dialog/dialog.actions';
import {DialogNewReportComponent} from '../../../../new-report/new-report/dialog-new-report/dialog-new-report.component';
import {FolderComponentObject} from '../../../../shared/classes/folder-component-object';

@Component({
  selector: 'app-report-table-row-add-report',
  templateUrl: './report-table-row-add-report.component.html',
  styleUrls: ['./report-table-row-add-report.component.scss']
})
export class ReportTableRowAddReportComponent {
  @Input() public folder: FolderComponentObject;

  constructor(
    private readonly _store: Store<AppState>
  ) {}

  @HostListener('click') public onClick(): void {
    this._store.dispatch(
      dialogOpen({
        component: DialogNewReportComponent,
        disableClose: false,
        config: {
          width: '600px',
          height: 'auto',
        },
        data: {
          folder: this.folder.payload
        }
      })
    );
  }

}
